import React, { useEffect, useRef } from 'react';

export const Hero = ({ children }) => {
  const windowRef = useRef(null);

  useEffect(() => {
    // Simple mock of the tilt effect
    const handleMouseMove = (e) => {
      if (!windowRef.current) return;
      // This is a simplified version of the tilt logic
      // In a real scenario, we might want to port the exact math
      // For now, let's keep it static or rely on CSS hover if implemented there
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <section className="hero">
      <div id="prism-container-3d">
        {children}
      </div>
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-text">Lightning Send 1.0 is now available</span>
            <span className="badge-arrow">→</span>
          </div>
          <div className="hero-title-wrapper">

            <h1>Email for <br />Salesforce developers</h1>
          </div>
          <p className="hero-subtitle">
            The best developer experience for sending emails in Salesforce.
            A fluent, chainable API that replaces verbose Apex boilerplate with clean code.
          </p>
          <div className="hero-cta">
            <a href="#docs" className="btn-primary">Get Started</a>
          </div>
        </div>

        <div className="hero-visual">
          <div className="code-window" ref={windowRef}>
            <div className="window-header">
              <div className="dots">
                <span className="dot red"></span>
                <span className="dot yellow"></span>
                <span className="dot green"></span>
              </div>
              <div className="filename">EmailService.cls</div>
            </div>
            <div className="window-body">
              <pre><code>
                <span className="keyword">LSend</span>.<span className="method">emails</span>(){'\n'}
                &nbsp;&nbsp;.<span className="method">sender</span>(<span className="string">'onboarding@salesforce.com'</span>){'\n'}
                &nbsp;&nbsp;.<span className="method">to</span>(<span className="string">'user@gmail.com'</span>){'\n'}
                &nbsp;&nbsp;.<span className="method">subject</span>(<span className="string">'Hello World'</span>){'\n'}
                &nbsp;&nbsp;.<span className="method">html</span>(<span className="string">'&lt;strong&gt;It works!&lt;/strong&gt;'</span>){'\n'}
                &nbsp;&nbsp;.<span className="method">send</span>();
              </code></pre>
            </div>
          </div>
          <div className="glow-effect"></div>
        </div>
      </div>
    </section>
  );
};
